module.exports = __webpack_public_path__ + "img/unauthorized.ab6ea202.jpg";